<template>
  <div class="voucher__header-container">
    <div class="voucher__header-container__time">
      <label class="voucher__header-container__time-icon">
        <vc-material-icon
          style="font-size: 16px; display: flex"
          icon="alarm"
          class="voucher__header-container__time-icon--small"
        ></vc-material-icon>
      </label>
      <label class="voucher__header-container__time-text">{{ timer }}</label>
    </div>
    <div class="voucher__header-container__title">
      <label class="voucher__header-container__title-text">
        Seu diagnóstico contábil por IA - grátis.
      </label>
    </div>
    <div class="voucher__header-container__close" @click="$emit('close')">
      <vc-material-icon
        icon="close_small"
        class="voucher__header-container__close--small"
      ></vc-material-icon>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineEmits<{
  (e: string): void;
}>();

defineProps<{
  timer: string;
}>();
</script>

<style lang="scss">
.voucher {
  font-family: "Plus Jakarta Sans";
  &__header {
    cursor: pointer;
    &-container {
      height: 100%;
      display: grid;
      align-items: center;
      justify-content: space-between;
      grid-template-columns: fit-content(4.5rem) 1fr 24px;
      gap: 8px;
      cursor: pointer;

      &__time {
        background-color: #f2fdf6;
        padding: 4px;
        border-radius: 5px;
        gap: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        &-text {
          color: #0a5c36;
          font-weight: bold;
          font-size: 0.75rem;
          cursor: pointer;
          width: 2.2rem;
        }

        &-icon {
          color: #00cc66;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          &--small {
            font-size: 16px;
          }
        }
      }

      &__title {
        &-text {
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
          color: #00331b;
          cursor: pointer;
        }
      }

      &__close--small {
        font-size: 24px;
        display: flex;
        align-items: center;
        height: 100%;
      }
    }
  }
}
</style>
